import { render } from "./Simulator.vue?vue&type=template&id=3d45edb8"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
script.render = render

export default script